import { STATE_MACHINE_JOBS_HANDLER } from 'root/src/shared/descriptions/endpoints/endpointIds';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const stateMachineJobHandlerEndpoint = {
    [STATE_MACHINE_JOBS_HANDLER]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        isLowSpec: true,
    },
};
